export default "__VITE_ASSET__d9a38f4f__"